export function splitBySpace(str) {
  return str.trim().split(/\s+/);
}

export function filterTips(type, data = []) {
  return data.filter((value, index) => value?.type_name === type);
}

export function convertMessageDataToFormData(messageData) {
  const formData = new FormData();

  // Lặp qua các thuộc tính của messageData và thêm vào formData
  for (const key in messageData) {
    if (messageData.hasOwnProperty(key)) {
      formData.append(key, messageData[key]);
    }
  }

  return formData;
}
export function isUserInMessageList(user, newMessageList) {
  return newMessageList.some(
    (message) =>
      (message.sender_id === user.id && !message.seen) || (message.sender_id === user.id && message.seen === '0'),
  );
}

export function normalizeUserData(data) {
  return data.map((item) => ({
    ...item,
    id: parseInt(item.id, 10),
    is_guest: item.is_guest === '1',
  }));
}

export function normalizeMessages(messages) {
  return messages.map((item) => ({
    ...item,
    id: parseInt(item.id, 10),
    conversation_id: parseInt(item.conversation_id, 10),
    sender_id: parseInt(item.sender_id, 10),
    receiver_id: parseInt(item.receiver_id, 10),
    seen: item.seen === '1',
    is_edited: item.is_edited === '1',
    is_deleted: item.is_deleted === '1',
    reply_to_id: item.reply_to_id !== null ? parseInt(item.reply_to_id, 10) : null,
  }));
}

export function isUserIdExists(users, idToCheck) {
  return users.some(user => user.id === idToCheck);
}